import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import ErrorBoundary from './components/ErrorBoundary';

import './i18n';

import './styles/tokens.css';
import './styles/base.css';
import './styles/components.css';
import './styles/pages.css';
import './styles/portal.css';

/**
 * Evict any service worker, always.
 *
 * This app registers none — there is no workbox, no vite-plugin-pwa, nothing
 * that would install one. A worker found here therefore belongs to a previous
 * deployment of this domain, and it is serving a precache that names asset
 * bundles which no longer exist. That is a white screen for a returning
 * visitor, and it survives reloads.
 *
 * `public/sw.js` is the primary cure — a tombstone worker that unregisters
 * itself — because it reaches browsers whose cached bundle is too old to
 * contain this code. This is the second line: any browser that does get this
 * far cleans itself up, once, and never sees the worker again.
 */
if ('serviceWorker' in navigator) {
  navigator.serviceWorker
    .getRegistrations()
    .then((registrations) => registrations.forEach((r) => r.unregister()))
    .catch(() => {});
}

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <ErrorBoundary>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </ErrorBoundary>
  </StrictMode>
);
